module.exports = __webpack_public_path__ + "static/media/water4all.8b3c63fb.png";